export default{
  phones: [
    '+86 15928758550 （中国）',
    '+86 18349353270（中国）',
    '+1 4258668398 （アメリカ）',
    '+880 1825459736 （バングラデシュ）',
    '+60 182525593 （マレーシア）'
  ],
  menu:[
    {
      name: 'ホーム',
      component: 'home'
    },
    {
      name:'サービス',
      component: 'service',
      subMenu: [
        {
          title: 'コンサルティングサービス',
          childrens: [
            { name: '企業戦略と変革', component: 'enterprise' },
            { name: 'ビジネスプロセス', component: 'businessProcess' },
            { name: 'デジタルトランスフォーメーション', component: 'digital' },
            { name: '企業アプリケーション', component: 'enterpriseApplication'},
            { name: 'CRM', component: 'crm' }
          ],
        },
        {
          title: 'ビジネスサービス',
          childrens:[
            { name: 'ブロックチェーン', component: 'blockchains' },
            { name: '業務アプリケーション', component: 'businessApplication' },
            { name: 'データ分析', component: 'dataAnalytics' },
            { name: '人工知能 (AI)', component: 'artificialIntelligence' },
            { name: 'AI映像制作', component: 'aiVideoProduction' }
          ]
        },
        {
          title: 'テクニカルサービス',
          childrens: [
            { name: 'ソフトウェア開発・保守', component: 'softwareDevelopment' },
            { name: 'エンタープライズモビリティ', component: 'enterpriseMobility' },
            { name: 'インテリジェント製造', component: 'intelligentManufacturing' },
            { name: 'ネットワークセキュリティ', component: 'networkSecurity' },
            { name: 'グローバリゼーション/ローカリゼーション', component: 'globalization' },
            { name: 'ビッグデータ', component: 'bigData' },
            { name: 'IoT（モノのインターネット）', component: 'internetThings' },
            { name: 'クラウド', component: 'cloud' },
          ]
        },
        {
          title: 'アウトソーシングサービス',
          childrens: [
            { name: 'アプリケーションアウトソーシング', component: 'applicationOutsourcing' },
            { name: 'ビジネスプロセスアウトソーシング', component: 'businessProcessOutsourcing' },
            { name: 'カスタマーサービス', component: 'customerService' },
            { name: '人事(HR)', component: 'humanResource' },
            { name: 'ゲーム分野', component: 'gamingField' }
          ]
        }
      ]
    },
    {
      name:'業界',
      component: 'industry'
    },
    {
      name:'会社情報',
      component: 'aboutUs'
    },
    {
      name: '採用情報',
      component: 'jobs'
    },
    {
      name: 'お問い合わせ',
      component: 'contactUs'
    }
  ],
  languageList: [
    { name: '日本語', code: 8, tag: 'ja' },
    { name: '中文', code: 1, tag: 'zh' },
    { name: '英語', code: 2, tag: 'en' }
  ],
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      // {
      //   imgUrl: require('../../assets/images/home/home-banner.jpg'),
      //   title: 'グローバルITサービス企業',
      //   description: 'MaesInfoは中国と米国に拠点を持ち、グローバルなお客様に24時間体制でサービスを提供します。',
      //   component: ''
      // },
      // {
      //   imgUrl: require('../../assets/images/home/home-banner2.jpg'),
      //   title: '豊富な中上級人材の確保',
      //   description: '高品質かつ低コストの体制で、時間と予算内で遂行します。',
      //   component: ''
      // },
      {
        imgUrl: require('../../assets/images/home/home-banner4.jpg'),
        title: '企業のデジタル変革サービス',
        description: '',
        component: ''
      }
  ],
  // 服务列表
  serviceTitle: 'Maesのサービス',
  services: [
     // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称', size: 'big(比例最大), normal(比例第二大小), small(最小比例)'
     {
      imgUrl: require('../../assets/images/home/home-pic-14.jpg'),
      title: '産業自動化',
      description: '生産のコアロジックを再構築し、煩雑な重複作業から解放しましょう。',
      component: 'intelligentManufacturing',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-1.jpg'),
      title: 'ソフトウェア開発・保守',
      description: '企業の情報化が進む中、情報システムは大規模かつ複雑化しています。',
      component: 'softwareDevelopment',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-2.jpg'),
      title: '人工知能',
      description: 'AIは世界中の企業変革を促進します。',
      component: 'artificialIntelligence',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-3.jpg'),
      title: 'モノのインターネット',
      description: 'IoTはインターネットに続く新たなIT革命と考えられています。',
      component: 'internetThings',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-4.jpg'),
      title: 'ブロックチェーン',
      description: 'ブロックチェーンは分散型データストレージなど多様な用途を持つ技術です。',
      component: 'blockchains',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-5.jpg'),
      // title: '人力资源',
      // description: '人力资源外包服务是一个新的人才管理和服务方式',
      title: 'AI',
      description: 'データの海の中でAIが無限の可能性を開きます。',
      component: 'humanResource',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-6.jpg'),
      title: 'ビッグデータ',
      description: '今日、データはこれまで以上に私たちの生活のあらゆる場面に根付いています。',
      component: 'bigData',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-7.jpg'),
      title: 'デジタルトランスフォーメーション',
      description: '急速に進化する技術のもと、世界は大きく変化しており、最新技術に適応します。',
      component: 'digital',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-8.jpg'),
      title: '企業戦略と変革',
      description: 'ビジネストランスフォーメーションは戦略的な変革を意味します。',
      component: 'enterprise',
      size: 'normal'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-9.jpg'),
      title: 'アプリケーションアウトソーシング',
      description: 'MaesInfoのソフトウェア開発サービスは、アプリケーション開発とカスタム製品の構築を含みます。',
      component: 'applicationOutsourcing',
      size: 'big'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-10.jpg'),
      title: 'データ分析',
      description: 'MaesInfoは先進的なビッグデータ分析技術で収益成長を加速し、デジタル経済で成功を支援します。',
      component: 'dataAnalytics',
      size: 'big'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-11.jpg'),
      title: 'エンタープライズモビリティ',
      description: '効率的なワーク環境、コスト削減、リソース統合を実現します。',
      component: 'enterpriseMobility',
      size: 'normal'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-12.jpg'),
      title: 'ネットワークセキュリティ',
      description: 'インターネット時代において、サイバーセキュリティは事業運営に不可欠です。',
      component: 'networkSecurity',
      size: 'normal'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-13.jpg'),
      title: 'グローバリゼーション/ローカリゼーション',
      description: 'MaesInfoは顧客にスマートなITソリューションを提供するイノベーティブなサービス企業です。',
      component: 'globalization',
      size: 'normal'
    }
  ],
  //  行业信息
  industryTitle: '業界',
  industry: [
    // icon: '图标地址', title: '标题'， component: '点击跳转组件名称'
    {
      icon: require('../../assets/images/home/home-icon-1.png'),
      title: '銀行',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-2.png'),
      title: 'ハイテク',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-3.png'),
      title: '保険',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-4.png'),
      title: '金融',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-5.png'),
      title: '資本市場',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-6.png'),
      title: 'ソフトウェア',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-7.png'),
      title: 'エネルギー',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-8.png'),
      title: 'インターネット',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-9.png'),
      title: '自動車',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-10.png'),
      title: '医療・ヘルスケア',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-11.png'),
      title: '旅行',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-12.png'),
      title: '教育',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-13.png'),
      title: 'メディア・エンターテインメント',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-14.png'),
      title: '小売',
      component: 'industry'
    }
  ],
  footer: {
    p1: `+86(028) 6593-5363 (中国)`,
    p2: `+86 400-871-8663 (中国)`,
    p3: `+86 15928758550 (中国)`,
    p4: `+86 18349353270(中国)`,
    p5: `+1 4258668398 (アメリカ)`,
    p6: `+880 1825459736 (バングラデシュ)`,
    p7: `+60 182525593 (マレーシア)`,
    tell: `お問い合わせ`,
    phone: ' 183-4935-3270 / 400-871-8663',
    copyRight: 'MaesInfo(TM) Copyright© 2005-2023 MaesInfo Corporation. All rights reserved'
  }
}
